<template>
</template>

<script>
import { CONFIG } from "@/config.js"
export default {
    data() {
        return {
        }
    },
    created: function () {
        this.login();
    },
    methods: {
        login: function () {
            const params = {
                client_id: CONFIG.registerOauthClientId,
                response_type: "code",
                scope: "read",
                redirect_uri: CONFIG.vueAppUrl + "/oauth/callback"
            }
            if (this.$route.query?.path) {
                this.$cookies.set("pathRedirect", this.$route.query.path);
            }
            const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
            window.location.href = CONFIG.api.registerUrl + "/oauth/authorize/?" + queryString;
        },
    }
}
</script>

<style lang="scss">
.election_date {
    font-size: 1.4rem;
    color: #d40000;
    margin-bottom: 1.5rem;
    font-weight: 700;
}

.slogan-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: nowrap;
    .line-red {
        height: 4px;
        background-color: red;
        flex: 2;
        max-width: 200px;
    }
    .line-blue {
        height: 4px;
        background-color: #0072ce;
        flex: 1;
        max-width: 100px;
    }
    .slogan-text {
        font-family: 'Protest Riot', cursive;
        font-family: 'Protest Riot', sans-serif;
        font-size: 2rem;
        color: #004080;
        white-space: nowrap;
        padding: 0 1rem;
    }
}
</style>